arsluna.htmlElement = function ($) {
    "use strict";

    function buttonSmall(text, href, id, className, attributes, nowrap, title) {
        let retval = '',
            buttonText = text,
            button = '';
        if (nowrap !== undefined && nowrap !== null && nowrap === true) {
            buttonText.replace(' ', '&nbsp;');
        };
        button = '' +
            '<a' +
            ' href="' + href + '"' +
            (id !== undefined && id !== null && id.length > 0 ? ' id="' + id + '" ' : '') +
            ' class="button' + (className !== undefined && className !== null && className.length > 0 ? ' ' + className : '') + '"' +
            (attributes !== undefined && attributes !== null && attributes.length > 0 ? ' ' + attributes : '') +
            (title !== undefined && title !== null && title.length > 0 ? ' title="' + title + '"' : '') +
            '">' +
            '<span>' + buttonText + '</span>' +
            '</a>';
        return button;
    }
    return {
        buttonSmall: buttonSmall
    };
}(jQuery); // END arsluna.htmlElement
arsluna.utils = (function (arsluna, $) {
    "use strict";

    var self = {};

    self.formatMessage = function (message, params = {}) {
        return message.replace(/\{(\w+)\}/g, function (match, key) {
            return params[key] !== undefined ? params[key] : match;
        });
    };

    return self;

})(window.arsluna, jQuery);
